module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-account-not-set-up"
  }, [_c('PageHeader', {
    attrs: {
      "title": _vm.title,
      "sub-title": _vm.subTitle
    }
  }), _vm._v(" "), _c('form', {
    staticClass: "w-login-form"
  }, [_c('div', {
    staticClass: "w-login-form__row"
  }, [(_vm.customMessage) ? _c('p', {
    domProps: {
      "textContent": _vm._s(_vm.customMessage)
    }
  }) : _c('p', [_vm._v("\n        Your account is not set up to use " + _vm._s(_vm.productName) + ".\n        Please contact your site administrator.\n      ")])]), _vm._v(" "), _c('div', {
    staticClass: "w-login-form__row"
  }, [_c('ProductList', {
    attrs: {
      "products": _vm.continueItems
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "w-login-form__row"
  }, [_c('router-link', {
    staticClass: "w-button w-button--blue",
    attrs: {
      "to": "/login"
    }
  }, [_c('span', {
    staticClass: "w-button__label"
  }, [_vm._v("\n          Back to login\n        ")])])], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-218b5a9d","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/AccountNotSetup.vue
// module id = 589
// module chunks = 1